var themeNameLight = 'light';
var themeNameDefault = themeNameLight;
var themeNames = [themeNameLight, 'light-mobile', 'light-high-contrast-experimental'];

export { themeNameDefault, themeNameLight, themeNames };
